export class Pagination<K> {
    constructor(
        public previous: string,
        public next: string,
        public result: K[]
    ) {}
}
